<h3 *ngIf="anyBindersAudited && allCardsAudited">All active cards in checked Binders were audited.<br />
    Click [Update] to update Acumatica Customer Sample Books 'Last Checked' date.
</h3>

<div *ngIf="anyBindersAudited && !allCardsAudited">
    <div *ngFor="let containerDescr of containerDescriptions; let i=index">
        <div style="font-size:1.3em; color: #ccf; margin-bottom:5px;" [style.margin.top]="i==0 ? 0 : '10px'">
            {{containerDescr}}
        </div>

        <table class="card-audit-review" style="margin-left:1.5em;">
            <tbody *ngFor="let orderCard of cardsInContainer(containerDescr)">
                <tr>
                    <td colspan="3">
                        <mat-chip-list>
                            <mat-chip [style.backgroundColor]="LifeCycleColor(orderCard.kitComponent.LifeCycle)"
                                [style.color]="LifeCycleContrastColor(orderCard.kitComponent.LifeCycle)"
                                class="inventory-id-chip">
                                {{orderCard.kitComponent.InventoryID}}
                            </mat-chip>
                            {{orderCard.kitComponent.Description}}
                        </mat-chip-list>
                    </td>
                </tr>
                <tr>
                    <td colspan="2" style="padding-bottom: 1em;">
                        <mat-button-toggle-group name="fillSource" [value]="orderCard.source"
                            (change)="orderCard.source = $event.value">
                            <mat-button-toggle [value]="CardAuditFillSource.SalesRep"
                                [disabled]="!orderCard.RepAvail">My
                                Supply
                                <span *ngIf="orderCard.RepAvail">({{orderCard.RepAvail}})</span>
                            </mat-button-toggle>
                            <mat-button-toggle [value]="CardAuditFillSource.Shipment"
                                [disabled]="orderCard.WhseAvail === undefined"
                                (click)="confirmWhseSupplyShipment(orderCard)">
                                Order
                                <span *ngIf="orderCard.WhseAvail !== undefined">
                                    <mat-icon *ngIf="orderCard.WhseAvail <= 0">report</mat-icon>
                                    <mat-icon
                                        *ngIf="orderCard.WhseAvail < LowSupplyQtyThreshold && orderCard.WhseAvail > 0">
                                        warning
                                    </mat-icon>
                                </span>
                            </mat-button-toggle>
                            <mat-button-toggle [value]="CardAuditFillSource.Omit">omit</mat-button-toggle>
                        </mat-button-toggle-group>
                    </td>
                    <td style="width:25px;">
                        <mat-spinner [diameter]="25" color="accent"
                            *ngIf="orderCard.WhseAvail === undefined || orderCard.RepAvail === undefined"></mat-spinner>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>

<mat-checkbox [(ngModel)]="orderBinderShells">Order/Place Binder Shells</mat-checkbox>

<table [style.display]="orderBinderShells?'table':'none'" class="card-audit-review">
    <tbody *ngFor="let shell of orderBinders">
        <tr>
            <td colspan="3">
                {{shell.kitComponent.Description}}
            </td>
        </tr>
        <tr>
            <td colspan="2" style="padding-bottom: 1em;">
                <mat-button-toggle-group name="fillSource" [value]="shell.source"
                    (change)="shell.source = $event.value">
                    <mat-button-toggle [value]="CardAuditFillSource.SalesRep" [disabled]="!shell.RepAvail">My
                        Supply
                        <span *ngIf="shell.RepAvail">({{shell.RepAvail}})</span>
                    </mat-button-toggle>
                    <mat-button-toggle [value]="CardAuditFillSource.Shipment" [disabled]="shell.WhseAvail === undefined"
                        (click)="confirmWhseSupplyShipment(shell)">
                        Order<span *ngIf="shell.WhseAvail !== undefined">
                            <mat-icon *ngIf="shell.WhseAvail == 0">report</mat-icon>
                            <mat-icon *ngIf="shell.WhseAvail < LowSupplyQtyThreshold && shell.WhseAvail > 0">
                                warning
                            </mat-icon>
                        </span>
                    </mat-button-toggle>
                    <mat-button-toggle [value]="CardAuditFillSource.Omit">omit</mat-button-toggle>
                </mat-button-toggle-group>
            </td>
            <td style="width:25px;">
                <mat-spinner [diameter]="25" color="accent"
                    *ngIf="shell.WhseAvail === undefined || shell.RepAvail === undefined"></mat-spinner>
            </td>
        </tr>
    </tbody>
</table>

<mat-divider></mat-divider>

<div *ngIf="anyShippedComponents" style="margin:0.25em 0;">
    <div style="margin: 0.25em 0;">Ship To:</div>
    <mat-button-toggle-group style="width:100%;" [value]="shipTo" (change)="shipTo = $event.value">
        <mat-button-toggle style="width:50%;" [value]="RepOrderShipToEnum.Customer">Directly to Customer
        </mat-button-toggle>
        <mat-button-toggle style="width:50%;" [value]="RepOrderShipToEnum.SalesRep">Me - I'll Deliver them
        </mat-button-toggle>
    </mat-button-toggle-group>

    <div *ngIf="shipTo == RepOrderShipToEnum.Customer" style="margin-top:0.2em;">
        <mat-form-field appearance="fill" style="width:100%;">
            <mat-label>Customer Location</mat-label>
            <mat-select [(ngModel)]="shipToLocation" name="shipToLocation">
                <mat-option *ngFor="let loc of customerLocations" [value]="loc">
                    <div class="customerLocation">
                        {{loc.LocationID}} - {{loc.LocationName}}<br />
                        {{loc.AddressLine1}}<br />
                        {{loc.City}}, {{loc.State}} {{loc.PostalCode}}
                    </div>
                </mat-option>
            </mat-select>
        </mat-form-field>

        <so-shipto-input [order]="order" [customer]="customer"></so-shipto-input>
    </div>
</div>

<button mat-raised-button color="primary" style="margin-top:2em; width: 95vw;" (click)="placeOrder()">Update audit &
    Place Cards/Binders</button>